import { useThemeAppEmbedStatus } from 'hooks/useThemeAppEmbedStatus';
import { Button } from './Button';
import { StorefrontSetupGuidance } from './StorefrontSetupGuidance';

/** Theme configuration evidence only. It does not establish cart runtime health. */
export const ThemeAppEmbedStatus = () => {
  const { storeId, shopDomain, connectionNeeded, status, editorUrl, message, check, openEditor } = useThemeAppEmbedStatus();
  if (!storeId) return null;

  return (
    <section aria-label="Theme app embed" className="my-6 rounded-xl border border-blue-200 bg-blue-50 p-4">
      <h3 className="text-sm font-semibold text-slate-950">Theme app embed</h3>
      <p role="status" className="mt-1 text-sm text-slate-700">{message}</p>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        {editorUrl && (
          <Button onClick={openEditor}>
            {status === 'disabled' ? 'Enable theme app embed' : 'Open theme editor'}
          </Button>
        )}
        {status !== 'checking' && (
          <Button variant="outlined" onClick={() => check()}>
            {status === 'unavailable' ? 'Retry embed check' : 'Check embed status'}
          </Button>
        )}
        {['unavailable', 'unsupported', 'wrong_app'].includes(status) && (
          <a href="https://help.shipaid.com" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-blue-700 underline">
            Get installation help
          </a>
        )}
      </div>
      <StorefrontSetupGuidance key={`${storeId}:${status}`} status={status} editorAvailable={Boolean(editorUrl)}
        shopDomain={shopDomain} connectionNeeded={connectionNeeded} />
    </section>
  );
};
